import axios from 'axios';
import config from '../config';
import { LoginResponse, User } from '../types/api';

// 创建axios实例
const api = axios.create({
  baseURL: config.API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;
    
    if (response) {
      const { status, data } = response;
      
      switch (status) {
        case 401:
          // 未授权，清除token并跳转到登录页
          localStorage.removeItem('token');
          window.location.href = '/login';
          break;
        case 403:
          // 权限不足
          console.error('权限不足:', data?.message || 'Access denied');
          break;
        case 404:
          // 资源不存在
          console.error('资源不存在:', data?.message || 'Resource not found');
          break;
        case 409:
          // 资源冲突
          console.error('资源冲突:', data?.message || 'Resource conflict');
          break;
        case 422:
          // 数据验证失败
          console.error('数据验证失败:', data?.message || 'Validation failed');
          break;
        case 500:
          // 服务器内部错误
          console.error('服务器内部错误:', data?.message || 'Internal server error');
          break;
        default:
          console.error(`API错误 ${status}:`, data?.message || 'Unknown error');
      }
    } else if (error.request) {
      // 网络错误
      console.error('网络错误:', '无法连接到服务器');
    } else {
      // 其他错误
      console.error('请求配置错误:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// 登录
export const login = (username: string, password: string) => {
  return api.post<LoginResponse>('/auth/login', { username, password });
};

// 获取用户信息
export const getProfile = () => {
  return api.get<User>('/auth/profile');
};

// 修改当前登录用户密码（所有角色）
export const changePassword = (oldPassword: string, newPassword: string) => {
  return api.post<{ success: boolean }>('/auth/change-password', { oldPassword, newPassword });
};

// 导出配置信息
export const getConfig = () => {
  return {
    apiBaseUrl: config.API_BASE_URL,
    wsUrl: config.WS_URL,
    mqttUrl: config.MQTT_URL,
    isDevelopment: config.isDevelopment,
  };
};

export default api;
